import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import type { Title, TitleFunction } from '@promo/shared';

/**
 * Custom hook to fetch titles from the API
 * @param functionFilter - optional function to filter titles by
 */
export function useTitles(functionFilter?: TitleFunction) {
  return useQuery<Title[], Error>({
    queryKey: ['titles', functionFilter],
    queryFn: async () => {
      const params = functionFilter ? { function: functionFilter } : undefined;
      return get<Title[]>('/titles', params);
    },
    staleTime: 1000 * 60 * 30, // 30 minutes cache
  });
}

/**
 * Custom hook to fetch a single title by ID
 * @param titleId - the ID of the title to fetch
 */
export function useTitle(titleId: string) {
  return useQuery<Title, Error>({
    queryKey: ['title', titleId],
    queryFn: () => get<Title>(`/titles/${titleId}`),
    enabled: Boolean(titleId),
  });
} 